import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class GoogleMapsLoaderService {
  private apiKey = "AIzaSyDR9w7-MQ8D6I3xaXRsMIC7FPF87604m6I";
  private scriptId = "google-maps-script";

  loadGoogleMaps(language = "en"): Promise<void> {
    return new Promise((resolve, reject) => {
      const existingScript = document.getElementById(this.scriptId);

      // Remove the existing script if it exists
      if (existingScript) {
        existingScript.remove();
        // Also remove the global google object
        (window as any).google = undefined;
      }

      const script = document.createElement("script");
      script.id = this.scriptId;
      script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&language=${language}`;
      script.async = true;
      script.defer = true;

      script.onload = () => {
        resolve();
      };

      script.onerror = (error: any) => {
        reject(error);
      };

      document.body.appendChild(script);
    });
  }
}
